// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__lGF+M","root":"styles_root__h49Qo","description":"styles_description__PyHKB","note":"styles_note__XltiQ","actions":"styles_actions__miMfx"};